const machineStatus = Object.freeze({
  PendingApproval: 'PendingApproval',
  Approved: 'Approved',
  Rejected: 'Rejected',
  Retired: 'Retired',
});

export { machineStatus };
